import { createGlobalInvalidationTag } from '@adv-frontend/modules-query';

export const PROMOS_LIST_GLOBAL_TAG = createGlobalInvalidationTag('PromosList');
export const PROMO_RECOMMENDATIONS_GLOBAL_TAG = createGlobalInvalidationTag('PromoRecommendations');
export const DELIVERY_WAREHOUSES_GLOBAL_TAG = createGlobalInvalidationTag('DeliveryWarehouses');
export const COLLECTION_GLOBAL_TAG = createGlobalInvalidationTag('Collection');
